import { render, staticRenderFns } from "./checkup.vue?vue&type=template&id=103a683e&scoped=true"
import script from "./checkup.vue?vue&type=script&lang=js"
export * from "./checkup.vue?vue&type=script&lang=js"
import style0 from "./checkup.vue?vue&type=style&index=0&id=103a683e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103a683e",
  null
  
)

export default component.exports